import styled from 'styled-components';

const getInputStyles = props => {
  let color = '#383C42';
  let border = 'none';
  let borderBottom;
  let borderRadius = '4px';
  let height = '46px';
  let fontFamily = 'Open Sans';
  let fontSize = '16px';
  let fontWeight = 'normal';
  // ( desired height - line height - border size ( both sides) ) / topAndBottom
  let padding = `0 ${props.appendIcon ? 2.5 : 1}em 0 ${props.prependIcon ? 2.5 : 1}em`;
  const background = '#fff';

  switch (props.appearance) {
    case 'rounded':
      color = '#6C727F';
      border = '1px solid #d9d7d7';
      borderRadius = '1.7em';

      break;
    case 'default':
    default:
      border = '1px solid #cac8c8';
  }

  switch (props.size) {
    case 'small':
      height = '35px';
      break;
    case 'big':
      height = '55px;';
      break;
    case 'OPLLarge':
      height = '40px';
      break;
    case 'normal':
    default:
  }

  switch (props.version) {
    case 'abby':
      border = 'none';
      fontFamily = 'Playfair Display';
      borderBottom = '2px solid #d5d5d5';
      fontSize = '36px';
      fontWeight = '600';
      color = '#000000';
      padding = `0 ${props.appendIcon ? 2.5 : 0}em 0 ${props.prependIcon ? 2.5 : 0}em`;
      height = 'initial';
      break;
    case 'legacy':
    default:
  }

  return `
    color: ${color};
    border: ${border};
    ${borderBottom && `border-bottom: ${borderBottom}`};
    border-radius: ${borderRadius};
    height: ${height};
    font-family: ${fontFamily};
    font-weight: ${fontWeight};
    font-size: ${fontSize};
    padding: ${padding};
    background: ${background};
  `;
};

const getWrapperStyle = props => {
  let width = '60%';

  switch (props.size) {
    case 'small':
      width = '20%;';
      break;
    case 'big':
      width = '100%;';
      break;
    case 'normal':
    default:
  }

  return `
    width: ${width};
  `;
};

export const Wrapper = styled.div`
  position: relative;
  display: inline-block;

  ${props => !props.theme.legacy && getWrapperStyle(props)}
`;

export const InputIconWrapper = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  line-height: 1em;
  color: #d9d7d7;
  ${props => props.isPrepended && 'left: 1em;'}
  ${props => props.isAppended && 'right: 1em;'}
`;

export const AppendedIcon = styled.span``;

export const PrependedIcon = styled.span``;

export const StyledInput = styled.input`
  font-family: 'OpenSans', sans-serif;
  font-size: 16px;
  letter-spacing: -0.4px;
  box-sizing: border-box;
  width: 100%;
  background: transparent;

  ${getInputStyles}

  &::placeholder {
    line-height: 1.5em;
    letter-spacing: 0.2px;
    color: #6c727f;
  }

  &::-moz-placeholder {
    line-height: 46px;
  }

  &:disabled {
    background: rgba(0, 0, 0, 0.1);
  }
`;

export const ClearButton = styled.span.attrs({
  className: 'fa fa-times-circle',
})`
  color: #0078d4;
  cursor: pointer;
`;

export const FloatingLabel = styled.div`
  font-family: 'Mukta';
  font-weight: 600;
  color: #6c727f;
  position: absolute;
  pointer-events: none;
  top: 50%;
  font-size: 36px;
  left: 50%;
  transform: translate(-50%, -50%);

  ${props =>
    props.isFloating &&
    `
    color: #828282;
    font-size: 18px;
    top: 130%;
    transition: all 0.1s;
  `}
`;
